<template>
  <span style="cursor:pointer;" @click="openModal()">{{ admin.name }}</span>

  <div v-if="active">
    </div>
        <div class="modal fade bd-example-modal-lg_admin"  :id="'Modal' + TbtnId" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel"  v-if="active"
          aria-hidden="true" >
          <div class="modal-dialog modal-lg" >
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLongTitle" v-if="this.$root.guiPerm == 'ROOT'">관리자 수정</h5>
                <h5 class="modal-title" id="exampleModalLongTitle" v-if="this.$root.guiPerm == 'ENTERPRISE'">강사 수정</h5>


              </div>
              <div class="modal-body">
<i class="fas fa-check-circle"></i> 필수입력

                <table class="table">
                  <tbody>
                    <tr>
                      <td class="th_bg">관리자코드</td>
                      <td>자동생성</td>
                      <td class="th_bg"><i class="fas fa-check-circle"></i>사용여부</td>
                      <td>
                        <div class="input-group mb-12">
                          <div class="input-group-prepend">
                            <select class="hidtype" :value="nvl(changedData.suspended, Tadmin.suspended)"
                              :class="{'hidtype-changed': changedData.suspended}"
                              @input="doChange('suspended', $event.target.value)">
                              <option value="">사용</option>
                              <option value="퇴사자">미사용(퇴사)</option>
                              <option value="해지">미사용(해지)</option>
                              <option value="기타">미사용(기타)</option>
                              

                            </select>
                            <button class="btn btn-sm btn-danger" style="display:inline;" v-if="changedData.suspended"
                              @click="delete changedData.suspended"><i class="bi bi-arrow-counterclockwise"></i></button>


                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td class="th_bg">관리범위</td>
                      <td colspan="3">
                        <tree-btn :tree="$refs.manageRange" v-if="$refs.manageRange" />
                      </td>
                    </tr>

                    <!--tr>
                      <td class="th_bg"><i class="fas fa-check-circle"></i>로그인 허용 시작일</td>
                      <td>


                        <input type="date" class="hidtype" :value="nvl(changedData.startDate, Tadmin.startDate)"
                          :class="{'hidtype-changed': changedData.startDate}"
                          @input="doChange('startDate', $event.target.value)" placeholder="000-00-00000" />
                        <button class="btn btn-sm btn-danger" style="display:inline;" v-if="changedData.startDate"
                          @click="delete changedData.startDate"><i class="bi bi-arrow-counterclockwise"></i></button>


                      </td>
                      <td class="th_bg"><i class="fas fa-check-circle"></i>로그인 허용 종료일</td>
                      <td>
                        <input type="date" class="hidtype" :value="nvl(changedData.endDate, Tadmin.endDate)"
                          :class="{'hidtype-changed': changedData.endDate}"
                          @input="doChange('endDate', $event.target.value)" placeholder="000-00-00000" />
                        <button class="btn btn-sm btn-danger" style="display:inline;" v-if="changedData.endDate"
                          @click="delete changedData.endDate"><i class="bi bi-arrow-counterclockwise"></i></button>


                      </td>
                    </tr-->


                  </tbody>
                </table>



                <table class="table">
                  <tbody>
                    <tr>
                      <td class="th_bg"> <span v-if="this.$root.guiPerm == 'ENTERPRISE'"><i class="fas fa-check-circle"></i>강사 아이디</span>
                                        <span v-if="this.$root.guiPerm == 'ROOT'">아이디</span>

                      </td>

                      <td>{{ Tadmin.username }}
                      </td>
                      <td class="th_bg"><i class="fas fa-check-circle"></i>비밀번호</td>
                      <td><input type="password" class="hidtype" :value="nvl(changedData.password, Tadmin.password)"
                          :class="{'hidtype-changed': changedData.password}"
                          @input="doChange('password', $event.target.value)" placeholder="비밀번호" />
                        <button class="btn btn-sm btn-danger" style="display:inline;" v-if="changedData.password"
                          @click="delete changedData.password"><i class="bi bi-arrow-counterclockwise"></i></button>
                      </td>
                    </tr>
                    <tr>
                      <td class="th_bg">연락처</td>
                      <td><input class="hidtype" :value="nvl(changedData.contact, Tadmin.contact)"
                          :class="{'hidtype-changed': changedData.contact}"
                          @input="doChange('contact', $event.target.value)" placeholder="연락처" />
                        <button class="btn btn-sm btn-danger" style="display:inline;" v-if="changedData.contact"
                          @click="delete changedData.contact"><i class="bi bi-arrow-counterclockwise"></i></button></td>
                      <td class="th_bg">이메일</td>
                      <td><input class="hidtype" :value="nvl(changedData.email, Tadmin.email)"
                          :class="{'hidtype-changed': changedData.email}"
                          @input="doChange('email', $event.target.value)" placeholder="이메일" />
                        <button class="btn btn-sm btn-danger" style="display:inline;" v-if="changedData.email"
                          @click="delete changedData.email"><i class="bi bi-arrow-counterclockwise"></i></button></td>
                    </tr>
                    <tr>
                      <td class="th_bg"><span v-if="this.$root.guiPerm == 'ENTERPRISE'"><i class="fas fa-check-circle"></i>강사 이름</span>
                                        <span v-if="this.$root.guiPerm == 'ROOT'"><i class="fas fa-check-circle"></i>이름</span></td>
                      <td><input class="hidtype" :value="nvl(changedData.name, Tadmin.name)"
                          :class="{'hidtype-changed': changedData.name}" @input="doChange('name', $event.target.value)"
                          placeholder="아이디" />
                        <button class="btn btn-sm btn-danger" style="display:inline;" v-if="changedData.name"
                          @click="delete changedData.name"><i class="bi bi-arrow-counterclockwise"></i></button></td>
                      <td class="th_bg"><i class="fas fa-check-circle"></i>영문명</td>
                      <td><input class="hidtype" :value="nvl(changedData.engName, Tadmin.engName)"
                          :class="{'hidtype-changed': changedData.engName}"
                          @input="doChange('engName', $event.target.value)" placeholder="아이디" />
                        <button class="btn btn-sm btn-danger" style="display:inline;" v-if="changedData.engName"
                          @click="delete changedData.engName"><i class="bi bi-arrow-counterclockwise"></i></button></td>
                    </tr>
                    <tr>

                    </tr>
                  </tbody>
                </table>
<query-grid :config="config" ref="qg" v-if="display_loghistory">
  <template #items="props">
            <tr v-for="(record) in props.records" v-bind:key="record.id">
              <td scope="row">{{ record.id }}</td>
              <td>{{ record.created_at }}</td>
              <td>{{ record.last_req }}</td>
              <td>
                  <span v-if="record.grant_type == 'password'">비밀번호</span>
                  <span v-if="record.grant_type == 'refresh_token'">자동로그인</span>
                  <span v-if="record.grant_type == 'existing_session'">관리자 로그인</span>
                  </td>
              <td>{{ record.ip }}</td>
              <td>{{ this.getDisplayUA(record.user_agent) }}</td>
              <td>
                  <span v-if="record.status == 0">사용 중</span>
                  <span v-if="record.status == 1">로그아웃</span>
                  <span v-if="record.status == 2">정보 변경 강제 로그아웃</span>
                  <span v-if="record.status == 3">관리자 강제 로그아웃</span>
                  <span v-if="record.status == 95">로그인 세션 시간 초과</span>
                  <span v-if="record.status == 96">자동로그인 시간 초과</span>
                  </td>
              <td><button v-if="record.status == 0" class="btn btn-danger btn-sm" 
                    @click="logoutSess(record)" :class="{'disabled': record.is_current}">X</button>
              </td>
            </tr>
          </template>
          <template #actions>
          <button class="btn btn-danger" @click="logoutAll();">모두 로그아웃</button>
          </template>

</query-grid>
              </div>
              <div class="modal-footer flex_center">
                <button type="button" class="btn btn-danger" @click="doSend()">수정</button>

<button type="button" class="btn btn-secondary" v-if="this.$root.guiPerm == 'ROOT'"  @click="display_loghistory = !display_loghistory">로그인 기록보기</button>
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">닫기</button>

              </div>
            </div>
          </div>
        </div>
    <Tree v-if="this.$root.guiPerm == 'ROOT'" :key="$route.path" :tree-data="this.$root.businesses" multiple render-button :callback="selectedBiz" selected :selectedNodeIds="this.Tadmin.bizIds" ref="manageRange" />
    <Tree v-if="this.$root.guiPerm == 'ENTERPRISE'" :key="$route.path" :tree-data="this.$root.businesses" :selectable="['CLASS']" multiple render-button :callback="selectedBiz" selected :selectedNodeIds="this.Tadmin.bizIds" ref="manageRange" />
</template>


<script>
  // @ is an alias to /src

  import Tree from "../Tree";
  import Business from "../Business";
  import axios from "axios";
  import TreeBtn from '../treeBtn.vue';
  import QueryGrid from '../QueryGrid.vue';
  import parser from 'ua-parser-js';

  export default {
    name: 'Home',
    components: {
      Tree,
      Business,
      TreeBtn,
      QueryGrid
    },
    mounted() {
      this.Tadmin = this.admin;
    },
    watch: {
      admin(){
this.Tadmin = this.admin;
      }
    },
    props: {
      admin: {
        type: Object,
        default: {}
      },
      btnId: String
    },
    methods: {
            nvl(str, altStr){
        if(typeof str == "undefined" || str == null) str = altStr ;
         return str ;

      },
      doChange(name, value) {
        if (this.Tadmin[name] === value) {
          delete this.changedData[name];
        } else {
          this.changedData[name] = value;
        }
      },
      selectedBiz(biz) {
        this.selBiz = biz;
      },
            openModal() {
        this.active = true;
        this.modifyMode(this.Tadmin)
        this.$nextTick(function(){
          var modalDom = document.getElementById("Modal" + this.TbtnId);
          var modal = (bootstrap.Modal.getOrCreateInstance(modalDom));
          modalDom.addEventListener('hidden.bs#Modal', function (event) {
            this.active = false;
          })
          //console.log(this.Tadmin.type);
          modal.show();

        this.$refs.qg.search();       
        
        });

      },
      doSend() {
        // 업데이트일 경우 patch /businesses/번호
        // 신규일 경우 post /businesses 후 post /admins 후 post /admins/번호/grants
        var data = this.changedData;




        var send = {
          method: this.creating ? "post" : "patch",
          url: '/admins' + "/" + this.Tadmin.id,
          data: data
        };

        //console.log(this.selBiz);
        //return;

            if(!this.selBiz.length){
                //if(!confirm("아무 기관도 선택하지 않았습니다. 이 관리아이디는 로그인 할 수 없게 됩니다. 의도한 동작이 맞을 경우에만 확인을 누르세요.")) return;
                $.notify({
                  // options
                  message: '최소 1개 이상의 관리범위를 지정하셔야 합니다. '
                }, {
                  // settings
                  type: 'danger',
                  z_index: 9999
                });
                return;
            }
              axios.post('/admins/' + this.Tadmin.id + '/grants', {
                grant: this.selBiz.join(",")
              }).then((response2) => {
                if (response2.data.error) {
                  $.notify({
                    // options
                    message: '처리할 수 없습니다 ' + response2.data.error
                  }, {
                    // settings
                    type: 'danger',
                    z_index: 9999
                  });
                } else {
                  // 마지막으로 grant

          (bootstrap.Modal.getInstance(document.getElementById('Modal' + this.TbtnId))).hide();
                  $.notify({
                    // options
                    message: '처리되었습니다'
                  }, {
                    // settings
                    type: 'success',
                    z_index: 9999
                  });
this.$refs.qg.search()


                }
              })

          if(Object.keys(this.changedData).length){

          axios(send).then((response) => {
            if (response.data.error) {
              $.notify({
                // options
                message: '처리할 수 없습니다. ' + response.data.error
              }, {
                // settings
                type: 'danger',
                z_index: 9999
              });
            } else {
              $.notify({
                // options
                message: '처리되었습니다'
              }, {
                // settings
                type: 'success',
                z_index: 9999
              });
              this.$refs.qg.search()
            }


          })

          }


      },
      logoutSess(sess){
        axios.delete("/admins/" + this.admin.id + "/sessions/" + sess.id).then(() => {
                        $.notify({
                // options
                message: '처리되었습니다'
              }, {
                // settings
                type: 'success',
                z_index: 9999
              });
              this.$refs.qg.search()
        })
      },
      logoutAll(){
        if(confirm("이 컴퓨터를 제외하고 모두 로그아웃됩니다. 계속할까요?")){
          this.logoutSess({id: "all"})
        }
      },
      modifyMode(record){
        this.creating = false;
        this.changedData = {};
        this.Tadmin =  {
          "id": record.id,
          "username": record.username,
          "password": "****",
          "name": record.name,
          "engName": record.engName,
          "contact": record.contact,
          "email": record.email,
          "bizIds": record.bizIds,
          "suspended": record.suspended,
          "type": record.type
        }
        this.$refs.manageRange.reset(record.bizIds.split(", "));
        this.selBiz = record.bizIds.split(", ");

        //console.log(this.selBiz)
        
      },
      getDisplayUA(str){
        var ua = parser(str);
        return ua.os.name + " " + ua.browser.name
      }
    },
    data() {
      return {
        selBiz: [],
        creating: false,
        Tadmin: {
          "username": "",
          "password": "",
          "name": "",
          "engName": "",
          "contact": "",
          "email": "",
        },
        display_loghistory: false,
        changedData: {

        },
                TbtnId: this.btnId || Math.random().toString().substr(2, 5),
                active: false,
                 config: {
    "name": "로그인 기록",
    "req_endpoint": "/admins/" + this.admin.id + "/sessions",
    "default_limit": 20,
    "disable_init_search": true,
    "search_fields": [
        {
            "id": "search",
            "name": "아이피검색",
            "type": "text",
            "placeholder": "IP로 검색"
        },

                {
            "id": "grant_type",
            "name": "로그인 방법",
            "type": "switch",
            "filter_type": {
                "password": {name: "직접입력", "css": {width: "140px!important"}},
                "refresh_token": {name: "자동", "css": {width: "140px!important"}},
                "existing_session":  {name: "LMS로그인", "css": {width: "140px!important"}},
            }
        },
        {
            "id": "os_filter",
            "name": "운영체제",
            "type": "switch",
            "filter_type": {
                "Windows NT 10.0": {name: "Windows 10/11", "css": {width: "180px!important"}},
                "Windows NT 6.": {name: "Windows 8.1이하", "css": {width: "180px!important"}},
                "Linux; Android ": {name: "Android", "css": {width: "180px!important"}},
                "Macintosh; Intel Mac OS X 10":  {name: "Mac", "css": {width: "180px!important"}},
                "iPhone; U": {name: "iphone", "css": {width: "180px!important"}}
            }
        },
                {
            "id": "status_filter",
            "name": "상태",
            "type": "switch",
            "filter_type": {
                0: {name: "Login", "css": {width: "180px!important"}},
                1: {name: "Logout", "css": {width: "180px!important"}},
                95:{name: "Timeout(Session)", "css": {width: "180px!important"}},
                96:{name: "Timeout(Login)", "css": {width: "180px!important"}},
                2: {name: "정보 변경 강제 로그아웃", "css": {width: "180px!important"}},
                3: {name: "강제아웃(관리자)", "css": {width: "180px!important"}}
            }
        },
                {
            "id": "filter_date",
            "name": "시간검색",
            "type": "date",
            "filter_type": {
                "created_at": "로그인 시간",
                "access_token_expiry": "로그인 세션 만료 시간",
                "refresh_token_expiry": "자동로그인 만료 시간",
                "logout_time": "로그아웃 시간",
                "last_req": "마지막 사용 시간"
            }
        }
    ],
    "columns": [
        {
            "id": "id",
            "sortable": true,
            "name": "번호",
            "excel_print": v=>{return v.id}
        },
        {
            "id": "created_at",
            "sortable": true,
            "name": "로그인 시간",
            "excel_print": v=>{return v.created_at}
        },

        {
            "id": "last_req",
            "name": "마지막 사용 시간",
            "sortable": true,
            "excel_print": v=>{return v.last_req || ''}
        },
        {
            "id": "grant_type",
            "name": "로그인 방법",
            "sortable": true,
            "excel_print": v=>{var a={"password":"비밀번호","refresh_token":"자동로그인","existing_session": "관리자 로그인"};return a[v.grant_type]}
        },
                {
            "id": "ip",
            "name": "IP",
            "sortable": true,
            "excel_print": v=>{return v.ip || ''}
        },
                {
            "id": "user_agent",
            "name": "브라우저 정보",
            "sortable": true,
            "excel_print": v=>{var ua = parser(v.user_agent);return ua.os.name + " " + ua.browser.name}
        },
                {
            "id": "status",
            "name": "상태",
            "sortable": true,
            "excel_print": v=>{var a={
                0: "로그인됨",
                1: "로그아웃됨",
                95: "로그인 세션 시간 초과",
                96: "자동로그인 시간 초과",
                2: "정보 변경 강제 로그아웃",
                3: "관리자가 강제 로그아웃"
            };return a[v.status]}
        },
                {
            "id": "task",
            "name": "작업"
        },
    ],
}
      }
    }
  }
</script>


<style>
  .hidtype {
    border: 0;
    text-align: center;
  }

  .hidtype-error {
    color: red;
  }

  .hidtype-changed {
    color: goldenrod;
  }
</style>
